import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CatalogueModal from "./catalogue";
import { FiChevronDown } from "react-icons/fi";
import "./nav.css";

import { getPublicRequest } from "../api/auth";
import API_ROUTES from "../components/config/apiConfig";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  const [menus, setMenus] = useState([]);
  const [brands, setBrands] = useState([]);

  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);

  const [showModal, setShowModal] = useState(false);

  // ✅ Scroll effect
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    getPublicRequest(API_ROUTES.GET_CATEGORIES)
      .then((res) => {
        if (res.success) {
          const filtered = res.data.filter(cat => cat.is_master === false);
          setCategories(filtered);
        }
      })
      .catch((err) => console.log("Category Error:", err));
  }, []);

  // ✅ Fetch Menus
  useEffect(() => {
    getPublicRequest(API_ROUTES.GET_MENUS)
      .then((res) => res.success && setMenus(res.data))
      .catch((err) => console.log("Menu Error:", err));
  }, []);

  // ✅ Fetch Brands
  useEffect(() => {
    getPublicRequest(API_ROUTES.GET_BRANDS)
      .then((res) => res.success && setBrands(res.data))
      .catch((err) => console.log("Brand Error:", err));
  }, []);

  // ✅ Main Logo (first brand OR fallback)
  const mainLogo = brands.length > 0 ? brands[0].icon_url : "/images/logo.png";

  return (
    <nav className={`custom-navbar navbar navbar-expand-md ${scrolled ? "scrolled" : ""}`}>
      <div className="container">

        {/* ✅ LOGO (Dynamic) */}
        <Link className="navbar-brand" to="/">
          <img className="logo" src={mainLogo} alt="logo" />
        </Link>

        {/* TOGGLER */}
        <button className="navbar-toggler" onClick={() => setOpen(!open)}>
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* MENU */}
        <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto align-items-center">

            {/* 🔥 MENUS */}
            {menus.map((menu) => {

              // 🔥 CATALOGUE
              if (menu.title?.toLowerCase() === "catalogue") {
                return (
                  <li key={menu.id} className="nav-item">
                    <button className="nav-link btn" onClick={() => setShowModal(true)}>
                      {menu.title}
                    </button>
                  </li>
                );
              }

              // 🔥 PRODUCT (ONLY HERE dropdown + categories)
              if (menu.title?.toLowerCase() === "products") {
                return (
                  <li
                    key={menu.id}
                    className="nav-item dropdown"
                    onMouseEnter={() => setActiveMenu(menu.id)}
                    onMouseLeave={() => {
                      setActiveMenu(null);
                      setActiveCategory(null);
                    }}
                  >
                    <button className="nav-link btn product-btn d-flex align-items-center gap-1">
                      <span>{menu.title}</span>
                      <FiChevronDown
                        className={`product-chevron ${activeMenu === menu.id ? "rotate" : ""
                          }`}
                      />
                    </button>

                    <ul className={`main-menu ${activeMenu === menu.id ? "show" : ""}`}>
                      {categories.map((cat) => (
                        <li
                          key={cat.id}
                          className={`submenu ${activeCategory === cat.id ? "active" : ""
                            }`}
                          onMouseEnter={() => setActiveCategory(cat.id)}
                          onMouseLeave={() => setActiveCategory(null)}
                        >
                          <div className="submenu-header">

                            {/* CATEGORY LINK */}
                            <Link
                              className="submenu-main-link"
                              to={`/category/${cat.slug}`}
                            >
                              <span className="menu-text">{cat.name}</span>
                            </Link>

                            {/* CHEVRON ONLY IF CHILDREN */}
                            {cat.children?.length > 0 && (
                              <FiChevronDown
                                className={`chevron ${activeCategory === cat.id ? "rotate" : ""
                                  }`}
                              />
                            )}
                          </div>

                          {/* SUB MENU */}
                          {cat.children?.length > 0 && (
                            <ul className="sub-menu">
                              {cat.children.map((sub) => (
                                <li key={sub.id}>
                                  <Link to={`/category/${sub.slug}`}>
                                    {sub.name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              }

              // 🔥 NORMAL MENU (NO ICON)
              return (
                <li key={menu.id} className="nav-item">
                  <Link className="nav-link" to={`/${menu.slug || ""}`}>
                    {menu.title}
                  </Link>
                </li>
              );
            })}

            {/* 🔥 BRANDS (Right side logos) */}
            {brands.length > 1 && (
              <li className="nav-item brands-nav">
                <div className="brands-wrapper">
                  {brands.slice(1).map((brand) => (
                    <img
                      key={brand.id}
                      src={brand.icon_url}
                      alt={brand.title}
                      className="brand-logo"
                    />
                  ))}
                </div>
              </li>
            )}

          </ul>
        </div>
      </div>

      {/* MODAL */}
      <CatalogueModal
        show={showModal}
        onClose={() => setShowModal(false)}
      />
    </nav>
  );
}

export default Navbar;